import React from 'react';
import { GitHubCalendar } from 'react-github-calendar';
import { useTheme } from '../context/ThemeContext';

const GitHubActivity = () => {
    const { theme: currentTheme } = useTheme();
    return (
        <div style={{ overflowX: 'auto', paddingBottom: 4 }}>
            <div style={{ minWidth: 700 }}>
                <GitHubCalendar
                    username="SalvatoreLS"
                    colorScheme={currentTheme}
                    fontSize={12}
                    blockSize={11}
                    blockMargin={2}
                    theme={{
                        dark: ['rgba(255,255,255,0.04)', 'rgba(244,63,94,0.25)', 'rgba(244,63,94,0.45)', 'rgba(244,63,94,0.7)', 'var(--accent)'],
                        light: ['rgba(0,0,0,0.04)', 'rgba(244,63,94,0.2)', 'rgba(244,63,94,0.4)', 'rgba(244,63,94,0.6)', 'var(--accent)']
                    }}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8, fontSize: 11, color: 'var(--text-dim)' }}>
                <span />
                <a href="https://github.com/SalvatoreLS" target="_blank" rel="noreferrer"
                    style={{ color: 'var(--accent)', textDecoration: 'none', fontSize: 11 }}>View on GitHub ↗</a>
            </div>
        </div>
    );
};

export default GitHubActivity;
